<template>
  <div :style="cssStyle" @wheel="msWheel">
    <slot />
  </div>
</template>

<script>

export default {
  props: {
    fixTop: {
      type: Number,
      default: 0
    },
    fixBottom: {
      type: Number,
      default: 0
    },
    attrName: {
      type: String,
      default: 'height'
    },
    itemData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      // cssStyle: { 'overflow': 'auto' },
      timer: false
    }
  },
  computed: {
    cssStyle () {
      let re = { overflow: 'auto' }
      let winHeight = this.$store.state.screenHeight
      re[this.attrName] = (winHeight - this.fixTop - this.fixBottom) + 'px'
      return re
    }
  },
  methods: {
    // resize () {
    //   var winHeight = this.$store.state.screenHeight
    //   this.cssStyle[this.attrName] = (winHeight - this.fixTop - this.fixBottom) + 'px'
    //   console.log(this.cssStyle)
    //   this.$forceUpdate()
    // },
    msWheel (event) {
      this.$emit('msWheel', event, this.itemData)
    }
  }
  // mounted () {
  //   this.resize()
  // },
  // watch: {
  //   '$store.state.screenHeight': function () { // 监听屏幕高度变化
  //     if (!this.timer) {
  //       this.timer = true
  //       let that = this
  //       setTimeout(function () {
  //         that.resize()
  //         that.timer = false
  //       }, 400)
  //     }
  //   }
  // }
}
</script>
